import axios from '@/lib/axios'
import { buildAdminRequestConfig } from '@/lib/organization-scoping'

function unwrapApiPayload(response) {
  const looksLikeAxiosResponse =
    response &&
    typeof response === 'object' &&
    'data' in response &&
    (typeof response.status === 'number' ||
      'headers' in response ||
      'config' in response ||
      'request' in response)

  return looksLikeAxiosResponse ? response.data : response
}

export async function getStripeConnectStatus({
  organizationId,
  refresh = false,
  accountContext = 'current',
} = {}) {
  const response = await axios.get(
    '/stripe-connect/status',
    buildAdminRequestConfig({
      organizationId,
      params: {
        ...(refresh ? { refresh: true } : {}),
        ...(accountContext !== 'current' ? { account_context: accountContext } : {}),
      },
    })
  )

  return unwrapApiPayload(response)
}

export async function getStripeConnectPaymentMethods({ organizationId } = {}) {
  return unwrapApiPayload(
    await axios.get('/stripe-connect/payment-methods', buildAdminRequestConfig({ organizationId }))
  )
}

export async function updateStripeConnectPaymentMethod({ organizationId, ...preference }) {
  return unwrapApiPayload(
    await axios.patch(
      '/stripe-connect/payment-methods',
      preference,
      buildAdminRequestConfig({ organizationId })
    )
  )
}

export async function createStripeConnectAccountSession({
  organizationId,
  surface,
  accountContext = 'current',
} = {}) {
  const response = await axios.post(
    '/stripe-connect/account-session',
    {
      ...(surface ? { surface } : {}),
      ...(accountContext !== 'current' ? { account_context: accountContext } : {}),
    },
    buildAdminRequestConfig({ organizationId })
  )

  return unwrapApiPayload(response)
}

export async function seedStripeConnectTestOnboardingData({ organizationId } = {}) {
  const response = await axios.post(
    '/stripe-connect/test-onboarding-data',
    null,
    buildAdminRequestConfig({ organizationId })
  )

  return unwrapApiPayload(response)
}

export async function resolveStripeConnectAccount({ stripeAccountId, target } = {}) {
  const response = await axios.get(
    '/stripe-connect/resolve-account',
    buildAdminRequestConfig({
      scoped: false,
      params: {
        stripe_account_id: stripeAccountId,
        target,
      },
    })
  )

  return unwrapApiPayload(response)
}
